import {filter, find, take} from 'lodash';

import {Option} from 'interfaces';

function getFilteredOptions<T>(selectedOptionId: T, options: Option<T>[], filterValue: string, maxItems = 50): Option<T>[] {
    const filteredOptions = filter(options, ({name}) => name.toLowerCase().includes(filterValue.toLowerCase()));
    const optionsToDisplay = take(filteredOptions, maxItems);

    if (!find(optionsToDisplay, {id: selectedOptionId})) {
        const selectedOption = find(options, {id: selectedOptionId}) as Option<T>;
        optionsToDisplay.unshift(selectedOption);
    }

    return optionsToDisplay;
}

export const selectUtils = {
    getFilteredOptions
};